<template>
  <div id="Gre">
    <v-expansion-panels v-if="savedSchool.gre_required === true" focusable class="px-2 mt-3 ">

      <v-expansion-panel class="mt-2  "  >
        <v-expansion-panel-header  class="light-blue--text text--darken-4">
          <v-layout row align-center pb-0 >
            <v-icon :color="greScoreCondition && grePercentileCondition ? 'green' : 'red'" >mdi-check-circle</v-icon>
            <v-icon color="blue darken-3" class="ml-2">mdi-file-document</v-icon>
            <span class="ml-2 blue--text text--darken-3 font-weight-medium">GRE</span>
          </v-layout>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">
          <v-card style="borderRadius:5px" class="pb-1 innerCardCover elevation-0" outlined >
              <v-layout  v-if="savedSchool.gre_required === true" class="pb-2 justify-center" :class="{red: !greScoreCondition || !grePercentileCondition, green: greScoreCondition && grePercentileCondition}">
                <span v-if="!greScoreCondition || !grePercentileCondition" class="white--text text-center mt-2">GRE Pending</span>
                <span v-else class="white--text text-center mt-2">GRE Completed</span>
              </v-layout>
              <v-layout v-else class="grey pb-2 justify-center">
                <span class="white--text text-center mt-2">GRE Not Required</span>
              </v-layout>


              <v-layout v-if="savedSchool.gre_required === true" mt-3 mb-3 align-center justify-center>
                  <!-- GRE INSTITUTION CODE -->
                  <v-layout v-if="savedSchool.gre_instituition_code !== '' " column align-center justify-center>
                    <span class="  mb-0  display-1 font-weight-regular blue--text text--darken-3">{{savedSchool.gre_instituition_code}}</span>
                    <span class="mt-1 caption font-weight-light black--text">Instituition Code</span>
                  </v-layout>

                  <!-- CASPA INSTITUITION CODE -->
                  <v-layout v-if="savedSchool.caspa_gre_instituition_code !== '' && savedSchool.caspa_gre_instituition_code !== undefined" column align-center justify-center>
                    <span class="  mb-0  display-1 font-weight-regular blue--text text--darken-3">{{savedSchool.caspa_gre_instituition_code}}</span>
                    <span class="mt-1 caption font-weight-light black--text">CASPA Instituition Code</span>
                  </v-layout>

                  <!-- INSTITUITION CODE NOT LISTED -->
                  <v-layout v-if="savedSchool.gre_instituition_code === '' && (savedSchool.caspa_gre_instituition_code === '' || savedSchool.caspa_gre_instituition_code === undefined)" align-center justify-center>
                    <span class="font-weight-light black--text">Instituition Code Not Listed</span>
                  </v-layout>
              </v-layout>

              <v-tabs
                v-model="greTab"
                background-color="transparent"
                color="basil"
                grow
                class="mt-3 px-2"
                hide-slider
                >
                <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">

                  Required Scores
                </v-tab>

                <v-tab active-class="primary white--text">
                <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                  My GRE
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="greTab">
                <!-- Minimum Required Scores Tab Item -->
                <v-tab-item class="pb-2">
                  <!-- MINIMUM GRE SCORE -->
                  <v-card v-if="savedSchool.gre_required === true"
                    style="borderRadius:5px"
                    class="mt-4 mx-4 elevation-0"
                    outlined
                    >
                    <v-layout
                      v-if="(savedSchool.gre_minimum_verbal_score !== '' && savedSchool.gre_minimum_verbal_score !== undefined && savedSchool.gre_minimum_verbal_score !== 0)
                      || (savedSchool.gre_minimum_quantitative_score !== '' && savedSchool.gre_minimum_quantitative_score !== undefined && savedSchool.gre_minimum_quantitative_score !== 0)
                      || (savedSchool.gre_minimum_writing_score !== '' && savedSchool.gre_minimum_writing_score !== undefined && savedSchool.gre_minimum_writing_score !== 0)
                      || (savedSchool.gre_minimum_combined_score !== '' && savedSchool.gre_minimum_combined_score !== undefined && savedSchool.gre_minimum_combined_score !== 0)"
                      class="red pb-2 justify-center"
                      >
                      <span  class="white--text text-center mt-2">Minimum Scores Required</span>
                    </v-layout>
                    <v-layout v-else class="grey pb-2 justify-center">
                      <span class="white--text text-center mt-2">Minimum Raw Scores Not Required</span>
                    </v-layout>


                    <v-card-text
                      v-if="(savedSchool.gre_minimum_verbal_score !== '' && savedSchool.gre_minimum_verbal_score !== undefined && savedSchool.gre_minimum_verbal_score !== 0)
                      || (savedSchool.gre_minimum_quantitative_score !== '' && savedSchool.gre_minimum_quantitative_score !== undefined && savedSchool.gre_minimum_quantitative_score !== 0)
                      || (savedSchool.gre_minimum_writing_score !== '' && savedSchool.gre_minimum_writing_score !== undefined && savedSchool.gre_minimum_writing_score !== 0)
                      || (savedSchool.gre_minimum_combined_score !== '' && savedSchool.gre_minimum_combined_score !== undefined && savedSchool.gre_minimum_combined_score !== 0)"
                      class="pt-2">

                      <!-- COMBINED SCORE -->
                      <v-layout  v-if="savedSchool.gre_minimum_combined_score !== '' && savedSchool.gre_minimum_combined_score !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Combined</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_combined_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_combined_score !== '' && savedSchool.gre_minimum_combined_score !== undefined"  class="mt-2 mb-1 "></v-divider>

                      <!-- VERBAL SCORE -->
                      <v-layout  v-if="savedSchool.gre_minimum_verbal_score !== '' && savedSchool.gre_minimum_verbal_score !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Verbal</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_verbal_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_verbal_score !== '' && savedSchool.gre_minimum_verbal_score !== undefined"  class="mt-2 mb-1 "></v-divider>

                      <!-- QUANTITATIVE SCORE -->
                      <v-layout  v-if="savedSchool.gre_minimum_quantitative_score !== '' && savedSchool.gre_minimum_quantitative_score !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_quantitative_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_quantitative_score !== '' && savedSchool.gre_minimum_quantitative_score !== undefined"  class="mt-2 mb-1 "></v-divider>

                        <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout  v-if="savedSchool.gre_minimum_writing_score !== '' && savedSchool.gre_minimum_writing_score !== undefined " mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_writing_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_writing_score !== '' && savedSchool.gre_minimum_writing_score !== undefined"  class="mt-2 mb-1 "></v-divider>




                    </v-card-text>

                  </v-card>

                  <!-- MINIMUM GRE PERCENTILE SCORES -->
                  <v-card
                    v-if="savedSchool.gre_required === true && (savedSchool.gre_minimum_combined_percentile !== '' && savedSchool.gre_minimum_combined_percentile !== undefined
                    || savedSchool.gre_minimum_verbal_percentile !== '' && savedSchool.gre_minimum_verbal_percentile !== undefined
                    || savedSchool.gre_minimum_quantitative_percentile !== '' && savedSchool.gre_minimum_quantitative_percentile !== undefined
                    || savedSchool.gre_minimum_writing_percentile !== '' && savedSchool.gre_minimum_writing_percentile !== undefined)"
                    style="borderRadius:5px"  class="mt-4 mx-4 elevation-0" outlined>
                    <v-layout class="red pb-2 justify-center">
                      <span  class="white--text text-center mt-2">Minimum Percentile Scores Required</span>
                    </v-layout>


                    <v-card-text class="pt-2">

                      <!-- COMBINED Percentile -->
                      <v-layout  v-if="savedSchool.gre_minimum_combined_percentile !== '' && savedSchool.gre_minimum_combined_percentile !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Combined</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_combined_percentile}}%</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_combined_percentile !== '' && savedSchool.gre_minimum_combined_percentile !== undefined"  class="mt-2 mb-1 "></v-divider>

                      <!-- VERBAL Percentile -->
                      <v-layout v-if="savedSchool.gre_minimum_verbal_percentile !== '' && savedSchool.gre_minimum_verbal_percentile !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Verbal</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_verbal_percentile}}%</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_verbal_percentile !== '' && savedSchool.gre_minimum_verbal_percentile !== undefined"  class="mt-2 mb-1 "></v-divider>

                      <!-- QUANTITATIVE Percentile -->
                      <v-layout  v-if="savedSchool.gre_minimum_quantitative_percentile !== '' && savedSchool.gre_minimum_quantitative_percentile !== undefined" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_quantitative_percentile}}%</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_quantitative_percentile !== '' && savedSchool.gre_minimum_quantitative_percentile !== undefined" class="mt-2 mb-1 "></v-divider>

                        <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout  v-if="savedSchool.gre_minimum_writing_percentile !== '' && savedSchool.gre_minimum_writing_percentile !== undefined " mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.gre_minimum_writing_percentile}}%</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.gre_minimum_writing_percentile !== '' && savedSchool.gre_minimum_writing_percentile !== undefined "  class="mt-2 mb-1 "></v-divider>




                    </v-card-text>

                  </v-card>
                </v-tab-item>

                <!-- My GRE Tab Item-->
                <v-tab-item class="pb-2">
                  <!-- Exam Status -->
                  <v-container>
                    <v-card   class="mt-4 innerCardCover elevation-0 " outlined >
                      <v-card-title  class="pa-0">
                          <v-layout class="grey lighten-3" align-center>
                            <v-layout  class="grey lighten-3" py-2 justify-center>
                              <p class="subtitle-1 text--primary  mb-0">Exam Status</p>
                            </v-layout>
                          </v-layout>
                      </v-card-title>
                      <v-card-text class="pb-0   ">
                        <v-layout  justify-center class="py-2" >
                          <span v-if="userGreExam" class="title"><span  v-bind:class="{ 'amber--text text--darken-3' : userGreExam.examStatus === 'Scheduled', 'green--text' : userGreExam.examStatus === 'Completed'}">{{userGreExam.examStatus | capitalizeString}}</span></span>
                          <span v-else class="title red--text"> Not Scheduled</span>
                        </v-layout>


                      </v-card-text>
                    </v-card>
                  </v-container>

                  <!-- My GRE Scores -->
                  <v-card v-if="userGreExam && userGreExam.examStatus === 'Completed' && userGreExam.exam_scores === true"
                    outlined
                    class="mt-4 innerCardCover"
                    >
                    <v-layout align-center justify-center class=" primary pb-2 ">
                      <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                      <span class="subtitle-1 mt-2 font-weight-regular white--text">  My GRE Scores </span>
                    </v-layout>

                    <v-card-text class="pt-2">

                      <!-- COMBINED SCORE -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Combined</span>
                          <span v-if="userGreExam.gre_combined_score !== '' && userGreExam.gre_combined_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_combined_score}}</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>

                      <!-- VERBAL SCORE -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Verbal</span>
                          <span v-if="userGreExam.gre_verbal_reasoning_score !== '' && userGreExam.gre_verbal_reasoning_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_verbal_reasoning_score}}</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider class="mt-2 mb-1 "></v-divider>

                      <!-- QUANTITATIVE SCORE -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                          <span v-if="userGreExam.gre_quantitative_reasoning_score !== '' && userGreExam.gre_quantitative_reasoning_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_quantitative_reasoning_score}}</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>

                        <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                          <span v-if="userGreExam.gre_analytical_writing_score !== '' && userGreExam.gre_analytical_writing_score !== undefined " class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_analytical_writing_score}}</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>




                    </v-card-text>

                  </v-card>

                  <!-- My GRE Percentile Scorres -->
                  <v-card v-if="userGreExam && userGreExam.examStatus === 'Completed' && userGreExam.exam_scores === true" outlined class="mt-4 innerCardCover">
                    <v-layout align-center justify-center class=" primary pb-2 ">
                      <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                      <span class="subtitle-1 mt-2 font-weight-regular white--text">  My GRE Percentile Scores </span>
                    </v-layout>

                    <v-card-text class="pt-2">

                      <!-- COMBINED Percentile -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Combined</span>
                          <span v-if="userGreExam.gre_combined_percentile_score !== '' && userGreExam.gre_combined_percentile_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_combined_percentile_score}}%</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>

                      <!-- VERBAL Percentile -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Verbal</span>
                          <span v-if="userGreExam.gre_verbal_percentile_score !== '' && userGreExam.gre_verbal_percentile_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_verbal_percentile_score}}%</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider class="mt-2 mb-1 "></v-divider>

                      <!-- QUANTITATIVE Percentile -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Quantitative (Math)</span>
                          <span v-if="userGreExam.gre_quantitative_percentile_score !== '' && userGreExam.gre_quantitative_percentile_score !== undefined" class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_quantitative_percentile_score}}%</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>

                        <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout   mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Analytical (Writing)</span>
                          <span v-if="userGreExam.gre_analytical_percentile_score !== '' && userGreExam.gre_analytical_percentile_score !== undefined " class="ml-4 blue--text text--darken-3 "> {{userGreExam.gre_analytical_percentile_score}}%</span>
                          <span v-else class="grey--text caption">Not Listed</span>
                      </v-layout>
                      <v-divider  class="mt-2 mb-1 "></v-divider>

                    </v-card-text>
                  </v-card>

                </v-tab-item>
              </v-tabs-items>


          </v-card>





          <!-- GRE Conditions -->
          <v-card
            v-if="savedSchool.gre_required === true && savedSchool.gre_minimum_year_completed !== '' && savedSchool.gre_minimum_year_completed !== undefined"
            style="borderRadius:5px"  class="mt-4 innerCardCover elevation-0"
            outlined
            >
            <v-layout justify-center  class=" grey lighten-3 pb-2">
              <span class="subtitle-1 mt-2 font-weight-regular"> Conditions </span>
            </v-layout>

            <v-card-text class="pt-2  ">
              <v-layout  column class="pl-0 ml-0 ">

                  <v-layout  mt-2 row   align-center  mx-0>
                    <span class=" font-weight-light black--text ">GRE must be completed within <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.gre_minimum_year_completed}} years</span></span>
                  </v-layout>

            </v-layout>

            </v-card-text>
          </v-card>

          <!-- GRE Exemptions-->
          <v-card
            v-if=" savedSchool.gre_required === true && (savedSchool.mcat_accepted_instead_gre === true || savedSchool.gre_exempt_masters_doctoral_degrees === true)"
            style="borderRadius:5px" class="mt-4 innerCardCover elevation-0" outlined
            >
            <v-layout justify-center class=" grey lighten-3 pb-2 ">
              <span class="subtitle-1 mt-2 font-weight-regular"> Exemptions </span>
            </v-layout>

            <v-card-text class="pt-2  ">
              <v-layout  column class="pl-0 ml-0 ">


                  <v-layout  v-if="savedSchool.mcat_accepted_instead_gre === true "  mt-2 row   align-center justify-space-between mx-0>
                    <span class=" font-weight-light black--text ">MCAT accepted in place of GRE</span>

                  </v-layout>
                    <!-- MINIMUM MCAT Score -->
                  <v-layout v-if="savedSchool.mcat_minimum_score_required !=='' && savedSchool.mcat_minimum_score_required !== undefined" row   mt-1 >
                    <span class="ml-3  grey--text "> Minimum MCAT Score: <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.mcat_minimum_score_required}}</span> </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.mcat_accepted_instead_gre === true "  class="mt-2 mb-1 "></v-divider>

                  <v-layout v-if="savedSchool.gre_exempt_masters_doctoral_degrees === true " mt-2 row   align-center justify-space-between mx-0>
                    <span class="font-weight-light black--text">GRE exempt with Masters or Doctoral Degree </span>

                  </v-layout>



              </v-layout>

            </v-card-text>
          </v-card>

          <!-- GRE Notes -->
          <v-card v-if="savedSchool.greNotes" outlined class=" mt-4 mb-4">
            <v-layout align-center justify-center class=" pb-1" >
              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
              <span class="font-weight-light align-center">Additional Notes </span>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="text-center">
              <span>{{savedSchool.greNotes}}</span>
            </v-card-text>
          </v-card>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkGreMixin from '@/mixins/requirementchecks/checkgremixin'
  export default {
    mixins: [userMixins,checkGreMixin ],
    props: ['savedSchool'],
    data() {
      return {
        greTab: null,
      }
    },
    computed: {
      userGreExam () {
         return this.userExams.find( exam => {
          if(exam.exam_type === 'GRE') {
            return true
          } else {
            return false
          }
          return exam.exam_type === 'GRE'
        })
      }
      },
      filters: {
      capitalizeString(string) {
        if( typeof string !== 'string') return ''
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}

.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/Gre.vue